export enum FEATURE_FLAG {
  TAG_FEATURE = 'tag_feature',
  LEA_FEATURE = 'lea_feature',
  HUBS_FEATURE = 'hubs_feature',
  CUSTOMERS_FEATURE = 'customers',
  CARGAS_FEATURE = 'cargas_feature',
  CARGAS_CREDIT_CHECK_FEATURE = 'cargas_credit_check_feature',
  CARGAS_REALTIME_CREDIT_CHECK_FEATURE = 'cargas_realtime_credit_check_feature',
  PRICING_FEATURE = 'pricing_feature',
  PRICING_V2_FEATURE = 'pricing_v2_feature',
  REPORTS_FEATURE = 'reports_feature',
  PANDA_BOX_FEATURE = 'panda_box_feature',
  VS_EXPORT_FEATURE = 'vs_export_feature',
  ROUTING_FEATURE = 'simple_shift_feature',
  PDI_EXPORT_FEATURE = 'pdi_export_feature',
  ENABLE_METER_FEATURE = 'lcr_meter_feature',
  DM2_EXPORT_FEATURE = 'dm2_export_feature',
  GL_MAPPING_FEATURE = 'gl_mapping_feature',
  HOUR_FRAME_FEATURE = 'hour_frame_feature',
  HIDE_ERP_ID_FEATURE = 'hide_erp_id_feature',
  BOL_PRICING_FEATURE = 'bol_pricing_feature',
  TANK_MONITORING = 'tank_monitoring_feature',
  HANDLE_TENANT_ROLES = 'handle_tenant_roles',
  DRIVER_RATE_FEATURE = 'driver_rate_feature',
  SPLASH_BLEND_FEATURE = 'splash_blend_feature',
  PRICING_TYPE_SETTING = 'pricing_type_setting',
  RENTAL_ASSET_FEATURE = 'rental_asset_feature',
  TOWER_EXPORT_FEATURE = 'towerx_export_feature',
  SYNC_WITH_3PL_FEATURE = 'sync_with_fdn_feature',
  AIMS_EXPORT_FEATURE = 'aims_export_feature',
  AIMS_TRANSFER_ORDER_EXPORT_FEATURE = 'aims_transfer_order_export_feature',
  LUBE_DELIVERY_FEATURE = 'lube_delivery_feature',
  SHIFT_BUILDER_FEATURE = 'shift_builder_feature',
  COMPANY_ADDRESS_LATITUDE = 'company_address_lat',
  CARDLOCK_FEATURE = 'card_lock_transaction_feature',
  COMMON_CARRIER_FEATURE = 'common_carrier_feature',
  ENABLE_ROUTING_FEATURE = 'enable_routing_feature',
  ROUTE_BUILDER_FEATURE = 'route_builder_feature',
  RB_ALLOW_PAST_ORDERS_FEATURE = 'rb_allow_past_orders_feature',
  VENDOR_PRICING_FEATURE = 'vendor_pricing_feature',
  TRANSFER_ORDER_FEATURE = 'transfer_order_feature',
  COMPANY_ADDRESS_LONGITUDE = 'company_address_lng',
  PERTROL_EXPORT_FEATURE = 'petrolrx_export_feature',
  CUSTOMER_IMPORT_FEATURE = 'customer_import_feature',
  BULK_SHIFT_MOVE_FEATURE = 'bulk_shift_move_feature',
  RECURRING_ORDER_FEATURE = 'recurring_order_feature',
  ORDER_LEVEL_TAX_FEATURE = 'order_level_tax_feature',
  CREDIT_APPROVAL_FEATURE = 'credit_approval_feature',
  RESOURCE_TENANT_FEATURE = 'resource_tenant_feature',
  SHOW_ROI_REPORT_FEATURE = 'show_roi_report_feature',
  EXTRACTION_ORDER_FEATURE = 'extraction_order_feature',
  PUSH_ORDER_WITH_3PL_FEATURE = 'push_order_to_fdn_feature',
  BOOKWORKS_INTEGRATION_FEATURE = 'bookworks_integration_feature',
  LOADING_ORDER_FEATURE = 'loading_order_feature',
  DELIVERY_ORDER_FEATURE = 'delivery_order_feature',
  MINIMUM_TYPE_FEE_FEATURE = 'minimum_type_fee_feature',
  CREDIT_CARD_TYPE_FEATURE = 'credit_card_type_feature',
  DIVERSION_NUMBERS_FEATURE = 'diversion_numbers_feature',
  QUICKBOOKS_ONLINE_FEATURE = 'quickbooks_online_feature',
  SHOW_ASSET_REPORT_FEATURE = 'show_asset_report_feature',
  IRELY_INTEGRATION_FEATURE = 'irely_integration_feature',
  COMPARABLE_PRODUCT_FEATURE = 'comparable_product_feature',
  RECALCULATE_PRICING_FEATURE = 'recalculate_pricing_feature',
  ALLOW_DUPLICATE_FEE_FEATURE = 'allow_duplicate_fee_feature',
  SHOW_GENERATED_NOTES_FEATURE = 'show_generated_notes_feature',
  TAX_CALCULATION_TYPE_FEATURE = 'tax_calculation_type_feature',
  AM_PM_ORDER_GROUPING_FEATURE = 'am_pm_order_grouping_feature',
  ENABLE_ADMIN_PORTAL = 'enable_admin_portal',
  QUICKBOOK_CREDIT_CHECK_FEATURE = 'quickbook_credit_check_feature',
  HUNT_AND_SONS_INTEGRATION_FEATURE = 'hunt_and_son_integration_feature',
  QUICKBRIDGE_DAYS_OVERDUE_FEATURE = 'use_quickbridge_due_date_feature',
  SYNC_CUSTOMERS_TO_QUICKBOOKS_FEATURE = 'sync_customers_to_quickbooks_feature',
  SYNC_SALES_ORDERS_TO_QUICKBOOKS_FEATURE = 'sync_sales_orders_to_quickbooks_feature',
  IMPORT_CUSTOMER_ASSETS_FEATURE = 'import_customer_assets_feature',
  CREDIT_CONTROL_MANAGER_FEATURE = 'credit_control_manager_feature',
  ENABLE_CREDIT_LEDGER_FEATURE = 'enable_credit_ledger_feature',
  DELIVERY_ONLY_CUSTOMER_FEATURE = 'delivery_only_customer_feature',
  PRODUCT_PURCHASE_LIMIT_FEATURE = 'product_purchase_limit_feature',
  SALES_REP_FOR_CC_EMAIL_FEATURE = 'sales_rep_for_cc_email_feature',
  DISPLAY_PRODUCT_SOLD_AS_FEATURE = 'display_product_sold_as_feature',
  IMPORT_RECURRING_ORDERS_FEATURE = 'import_recurring_orders_feature',
  ENABLE_NETSUITE_INTEGRATION_FEATURE = 'enable_netsuite_integration_feature',
  ENABLE_D1_INTEGRATION_FEATURE = 'd1_connect_feature',
  PRODUCT_NAME_WITH_ERP_ID_FEATURE = 'product_name_with_erp_id_feature',
  INHERIT_CUSTOMER_PRICING_FEATURE = 'inherit_customer_pricing_feature',
  ASSET_INVENTORY_TRACKING_FEATURE = 'asset_inventory_tracking_feature',
  CUSTOMER_NAME_ERP_ID_SEARCH_FEATURE = 'customer_name_erp_id_search_feature',
  MERGE_CUSTOMER_RESOURCES_FEATURE = 'merge_customer_resources_feature',
  EXCLUDE_MARGIN_IN_PRICING_FEATURE = 'exclude_margin_in_pricing_feature',
  ENABLE_2FA_AUTHENTICATION_FEATURE = 'enable_2fa_authentication_feature',
  EFFECTIVE_DATETIME_ON_TAX_FEATURE = 'effective_datetime_on_tax_feature',
  SEPARATE_PRODUCT_CODE_ERP_ID = 'separate_product_code_and_erp_id_feature',
  ENABLE_QUICKBASE_INTEGRATION_FEATURE = 'enable_quickbase_integration_feature',
  MASTER_APPLY_APPLICABLE_TAX_FEATURE = 'master_apply_applicable_tax_feature',
  SEND_CUSTOMER_PRICING_QUOTE_FEATURE = 'send_customer_pricing_quote_feature',
  COMPARABLE_LOADING_PRODUCTS_FEATURE = 'comparable_loading_products_feature',
  TANK_MONITORING_SHOW_PRODUCT_FEATURE = 'tank_monitoring_show_product_feature',
  SHOW_PERCENTAGE_BASED_ULLAGE_FEATURE = 'show_percentage_based_ullage_feature',
  BULK_PLANT_SHIFT_AUTO_CREATE_FEATURE = 'bulk_plant_shift_auto_create_feature',
  SHOW_SHIPTO_IN_CUSTOMER_EDIT_FEATURE = 'show_shipto_in_customer_edit_feature',
  SHOW_INVOICE_STATUS_ON_ORDERS_FEATURE = 'show_invoice_status_on_orders_feature',
  NOTIFY_ORDER_CREATE_TO_DRIVER_FEATURE = 'notify_order_create_to_driver_feature',
  AUTO_POPULATE_ORDER_FEATURE = 'populate_load_order_from_previous_shift_feature',
  ORDER_GROUP_READY_TO_SYNC_FEATURE = 'order_groups_ready_to_sync_status_feature',
  ENABLE_MANUAL_DELETION_OF_TAX_FEATURE = 'enable_manual_deletion_of_tax_feature',
  AlWAYS_REQUIRED_DELIVERY_ORDER_FEATURE = 'always_require_delivery_order_feature',
  BULK_DOWNLOAD_DELIVERY_RECEIPT_FEATURE = 'bulk_download_delivery_receipt_feature',
  TANK_MONITORING_SHOW_SAFE_ULLAGE_FEATURE = 'tank_monitoring_show_safe_ullage_feature',
  ENABLE_EXTERNAL_ID_IN_BOL_REPORT_FEATURE = 'enable_external_id_in_bol_report_feature',
  LOADING_ACCOUNT_INSTEAD_SUPPLIER_FEATURE = 'loading_account_instead_supplier_feature',
  ONLY_ASSIGNED_TRAILER_TO_TRACTOR_FEATURE = 'only_assigned_trailer_to_tractor_feature',
  ABILITY_TO_MARK_ORDER_AS_ARCHIVED_FEATURE = 'ability_to_mark_order_as_archived_feature',
  ADD_TRANSFERS_STATE_IN_BOL_REPORT_FEATURE = 'add_transfers_state_in_bol_report_feature',
  SYNC_PURCHASE_ORDERS_TO_QUICKBOOKS_FEATURE = 'sync_purchase_orders_to_quickbooks_feature',
  SYNC_EXTRACTION_ORDERS_TO_QUICKBRIDGE_FEATURE = 'sync_extraction_orders_to_quickbridge_feature',
  SYNC_PANDA_DOCUMENTS_TO_QUICKBEIDGE_FEATURE = 'sync_panda_documents_to_quickbridge_feature',
  SYNC_PRODUCT_DATA_FROM_QBO_FEATURE = 'qbo_sync_product_data_feature',
  ENABLE_INVOICE_IN_EXTRACTION_ORDER_FEATURE = 'enable_invoice_in_extraction_order_feature',
  Enforce_Single_Default_Delivery_Fee_Feature = 'enforce_single_default_delivery_fee_feature',
  SHIPTO_PREFERRED_TERMINAL_SUPPLIERS_FEATURE = 'shipto_preferred_terminal_suppliers_feature',
  SHOW_ADDITIONAL_COLUMN_IN_DELIVERY_ORDER = 'show_additional_column_in_delivery_order_feature',
  ENABLE_WIDE_DATE_RANGE_FOR_GRAPH_DATA_FEATURE = 'enable_wide_date_range_for_graph_data_feature',
  TANK_MONITORING_SHOW_HEIGHT_AND_VOLUME_FEATURE = 'tank_monitoring_show_height_and_volume_feature',
  ENABLE_COMPARABLE_PRODUCT_BY_DISPATCHER_FEATURE = 'enable_comparable_product_by_dispatcher_feature',
  ENFORCE_ERP_ID_ON_TAGS_FEATURE = 'enforce_erp_id_on_tags_feature',
  EMBEDDED_METABASE_FEATURE = 'embedded_metabase_feature',
  PICK_AND_PACK_FEATURE = 'pick_and_pack_feature',
  DASHBOARD_V2_FEATURE = 'dashboard_v2_feature',
  // BEST BUY
  LOGISTICS_MIGRATION_V1_FEATURE = 'logistics_migration_v1_feature',
  // this is a temporary flag, remove every instance later
  // ask tilak for more info
  NEW_ORDER_V3_FEATURE = 'new_order_v3_feature',
  INVOICE_NUMBER_FEATURE = 'invoice_feature',
  USE_PANDABOX_V2_FEATURE = 'use_panda_box_v2_feature',
  PANDABOX_FIRMWARE_UPDATE_FEATURE = 'pandabox_firmware_update_feature',
  DEFAULT_CONTINUOUS_DELIVERY_FEATURE = 'default_continuous_delivery_feature',
  SHOW_GENERATOR_RUNNING_HOURS = 'show_generator_running_hours_feature',
  SHOW_BOTH_CUSTOMER_NAME_AND_SHIPTO_NAME_IN_SHIFT_PLANNER_FEATURE = 'show_both_customer_name_and_ship_to_name_in_planner_feature',
  SHIP_TO_FEE_FEATURE = 'shipto_fee_feature',
  EMAIL_DELIVERY_RECEIPT_FEATURE = 'email_delivery_receipt',
  DELIVERY_NOTES_AT_ASSET_FEATURE = 'delivery_notes_at_asset_feature',
  SHOW_CUSTOMER_DETAILS_IN_WEEKLY_SHIFT_PLANNER_FEATURE = 'show_customer_details_in_weekly_shift_planner_feature',
  DEGREE_DAY_FEATURE = 'degree_day_feature',
  USE_LOCAL_TIMEZONE_FEATURE = 'use_local_timezone_feature',
  DIVERGENCE_ORDER_FEATURE = 'divergence_order_feature',
  CUSTOMER_PORTAL = 'customer_portal_feature',
  RFID_FEATURE = 'rfid_feature',
  USAGE_METRICS_FEATURE = 'usage_metrics_feature',
  QBO_FETCH_CREDIT_INFORMATION_FEATURE = 'qbo_fetch_credit_information_feature',
  HUNT_AND_SON_CREDIT_CHECK_FEATURE = 'hunt_and_son_credit_check_feature',
  TANK_MONITOR_OPERATION_MODE = 'tank_monitor_operational_mode',
  MAX_THRESHOLD_FOR_EXTRACTION_ORDER = 'max_threshold_for_extraction_order',
  MAX_THRESHOLD_FOR_DELIVERY_ORDER = 'threshold_for_order_creation',
  AUTO_ORDER_FILL_PERCENTAGE = 'auto_order_fill_percentage',
  SEQUENTIAL_LOADING_FEATURE = 'sequential_loading_feature',
  PARTIAL_DELIVERY_FEATURE = 'partial_delivery_feature',
  INVOICE_NOTES_FEATURE = 'enable_invoice_notes_feature',
  MANDATORY_STICK_READING_FEATURE = 'mandatory_stick_reading_feature',
  USE_PERCENTAGE_IN_STICK_READING_FEATURE = 'use_percentage_in_stick_reading_feature',
  ALLOW_WAREHOUSE_TO_WAREHOUSE_TRANSFER_ORDER_FEATURE = 'allow_warehouse_to_warehouse_transfer_order_feature',
  PRECISION_DIGIT_FOR_PRICES_FEATURE = 'precision_digit_for_prices',
  PRECISION_DIGIT_FOR_RATE_FEATURE = 'precision_digit_for_rate',
  PRESHIFT_CHECKLIST_FEATURE = 'preshift_checklist_feature',
  ENABLED_PUSHER_ON_ORDER_DETAIL_PAGE_FEATURE = 'enable_pusher_on_order_detail_page_feature',
  CUSTOMER_STANDARDIZED_SEARCH_V2_FEATURE = 'customer_list_v2_feature',
  USE_3PL_FOR_COMMON_CARRIER_FEATURE = 'use_3pl_for_common_carrier_feature',
  GROUP_LOADING_ORDER_FEATURE = 'group_loading_order_feature',
  ALERT_DRIVER_WHEN_FUEL_EXCEEDS_COMPARTMENT_OR_TANK_CAPACITY_FEATURE = 'alert_driver_when_fuel_exceeds_compartment_or_tank_capacity_feature',
  DO_NOT_CREATE_DEFAULT_COMPARTMENT_FOR_CATEGORIES_FEATURE = 'do_not_create_default_compartment_for_categories_feature',
  TEMPORARY_PRICING_FEATURE = 'temporary_pricing_feature',

  // Tank Monitor V2 Features
  TANK_MONITORING_EXPAND_TANK_MONITORS_BY_DEFAULT_FEATURE = 'tank_monitoring_expand_tank_monitors_by_default_feature',
  AGVANCE_INTEGRATION_FEATURE = 'agvance_integration_feature',
  RAW_PRICING_PARSER_FEATURE = 'raw_pricing_parser_feature',
  PRICING_PARSER_URL = 'pricing_parser_url',
  UPDATE_OG_DARK_MODE_FEATURE = 'update_og_dark_mode_feature',
  USE_FUEL_MEASUREMENT_FEATURE = 'use_fuel_measurement_feature',

  ADD_BOL_FIELD_IN_TRANSFER_ORDER_FEATURE = 'add_bol_field_in_transfer_order_feature',

  // AUTO REPLENISH
  TANK_MONITOR_ANALYTICS_FEATURE = 'tank_monitor_analytics_feature',

  SCHEDULE_CONTROLS_FEATURE = 'schedule_controls_feature',

  //LEM Features
  LEM_V2_FEATURE = 'lem_v2_feature',

  // LEO Feature
  LEO_FEATURE = 'leo_feature',

  // Unified View
  UNIFIED_VIEW_FEATURE = 'unified_view_feature',

  PREVENT_ORDER_CREATION_WITHOUT_PO_NUMBER_FEATURE = 'prevent_order_creation_without_po_number_feature',

  // Subscription Enforcement
  SEAT_ENFORCEMENT = 'seat_enforcement_feature',

  PANDA_PRICE_CALC_WITHOUT_HUB = 'price_calc_without_hub_feature',
  FREIGHT_TAXES_FEATURE = 'freight_taxes_for_pricing_v2_feature',

  // Webhook Integration
  WEBHOOK_CALLBACK_SETUP_FEATURE = 'webhook_callback_setup_feature',
  WEBHOOK_AUTH_KEY_FEATURE = 'webhook_auth_key_feature',
  WEBHOOK_OAUTH_FEATURE = 'webhook_oauth_feature',
  MULTI_METER_FEATURE = 'multi_meter_feature',
}

/**
 * Gate embedded customer pricing (v2) vs legacy in-app pricing UI; pass to `hasSettings` / `useHasSettings`.
 * Local dev: set `REACT_APP_FORCE_NEW_PRICING=true` to bypass the tenant flag (see `useHasSettings`).
 */
export const SHOW_NEW_PRICING = FEATURE_FLAG.PRICING_V2_FEATURE;

export enum USER_FEATURE_FLAG {
  DRIVERS = 'drivers',
  CUSTOMERS = 'customers',
  ALLOW_EDIT_HUB = 'allow_edit_hub',
  ALLOW_CREATE_HUB = 'allow_create_hub',
  ALLOW_USER_MANAGE_LEA = 'allow_user_manage_lea',
  CREDIT_CONTROL_MANAGER = 'credit_control_manager',
  ALLOW_USER_TO_MARK_ORDER_AS_ARCHIVED = 'allow_user_to_mark_order_as_archived',
  ALLOW_USER_TO_CREATE_OR_EDIT_LEA_QUESTIONNAIRE = 'allow_user_create_edit_lea_questionnaire',
}

export enum CUSTOMER_PORTAL_FLAG {
  DEFAULT_LINE_OF_SERVICE = 'default_line_of_service',
}
